"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const graphql_1 = require("../../../graphql");
const BaseAuthModal_1 = require("./BaseAuthModal");
const react_2 = require("@osmosys/react");
exports.ForgotPasswordModal = props => {
    return (react_1.default.createElement(BaseAuthModal_1.BaseAuthModal, Object.assign({ osysSubType: "forgotPassword", fields: ['email'], mutation: graphql_1.forgotPassword, title: "Forgot password to Osmosys?", buttonText: "Request password reset", getVars: ({ email }) => {
            return {
                data: {
                    email,
                },
            };
        }, formProps: {
            renderSuccess: data => {
                return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "ForgotPassword.TransactionalEmailId", "data-transactional-email-id": data && data.forgotPassword && data.forgotPassword.id }));
            },
            showCheckIconOnSuccess: true,
            successActions: () => {
                return [
                    {
                        label: 'Go to login',
                        to: '/login',
                    },
                    {
                        label: 'Email support',
                        onClick: () => {
                            window.location.href = 'mailto:contact@yellowbrim.com';
                        },
                    },
                ];
            },
            successMessage: () => 'An email with a link to reset your password is on its way. Please check your spam box if it is not in your inbox shortly. If you need further assistance, please email support.',
            successWrapperClassName: 'py-5 px-2',
        }, linkComp: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null,
                "Have a password reset link sent to you or try",
                ' ',
                react_1.default.createElement(react_router_dom_1.Link, { to: "/login" }, "logging in"),
                ".")) }, props)));
};
exports.default = exports.ForgotPasswordModal;
//# sourceMappingURL=ForgotPasswordModal.js.map